import {
    ChangeDetectionStrategy,
    Component,
    DoCheck,
    forwardRef,
    Injector,
    Input,
    OnChanges,
    SimpleChanges,
    ViewChild,
} from '@angular/core';
import {
    ControlValueAccessor,
    NG_VALUE_ACCESSOR,
    NgControl,
    NG_VALIDATORS,
    FormControl,
} from '@angular/forms';
import { MatSelect } from '@angular/material/select';

// tslint:disable-next-line: no-conflicting-lifecycle
@Component({
    selector: 'app-multiselect-email',
    templateUrl: './multiselect-email.component.html',
    styleUrls: ['./multiselect-email.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => MultiselectEmailComponent),
            multi: true,
        },
        {
            provide: NG_VALIDATORS,
            useExisting: MultiselectEmailComponent,
            multi: true,
        },
    ],
})
export class MultiselectEmailComponent
    implements OnChanges, ControlValueAccessor, DoCheck {
    @Input() value: any[];
    @Input() label: string;
    @Input() disabled = false;

    @Input() singleSelection = false;
    @Input() required = false;

    @ViewChild(MatSelect) oldSelect;

    isOpen = false;
    shouldOpen = false;
    tempRecipient;

    choices = [];
    selected = [];
    selectedOld = [];
    settings = {};
    onChanges = [];
    onTouched = [];
    touched = false;

    // public get invalid(): boolean {
    //     console.log(
    //         this.label,
    //         this.required,
    //         this.selected,
    //         this.required && (!this.selected || this.selected.length === 0)
    //     );
    //     return this.required && (!this.selected || this.selected.length === 0);
    // }

    // public get showError(): boolean {
    //     if (this.valid) {
    //         return false;
    //     } else {
    //         return true;
    //     }
    // }

    // public get errors() {
    //     if (this.valid) {
    //         return [];
    //     }

    //     return { field: 'Not valid' };
    // }

    // public get valid(): boolean {
    //     return !this.invalid;
    // }

    validate({ value }: FormControl) {
        // console.log('vAlidate', value);
        // console.log('Call validate', this.invalid, this.myForm.controls.length);
        return this.required && (!this.selected || this.selected.length === 0)
            ? { fieldInvalid: true }
            : null;
    }

    constructor(private injector: Injector) {}

    oldChange = () => {
        this.selected = this.choices.filter(
            v => this.selectedOld.indexOf(v.id) >= 0
        );
        this.formChanged(this.selected);
    };

    addRecipient = () => {
        console.log('addRecipient Click');
        this.choices = [
            { id: this.tempRecipient, itemName: this.tempRecipient },
            ...this.choices,
        ];
        this.selected = [
            { id: this.tempRecipient, itemName: this.tempRecipient },
            ...this.selected,
        ];
        this.selectedOld = this.selected.map(v => v.id);
        this.tempRecipient = '';

        this.formChanged(this.selected);
    };

    ngDoCheck() {
        if (this.shouldOpen && this.oldSelect) {
            this.oldSelect.open();
            this.shouldOpen = false;
        }
        const ngControl = this.injector.get(NgControl);
        if (!ngControl.control) {
            return;
        }
        this.touched = ngControl.control.touched;
    }

    private setOnChangeCallback(fn: any) {
        this.onChanges.push(fn);
    }

    private setOnTouchCallback(fn: any) {
        this.onTouched.push(fn);
    }

    setIsDisabled(isDisabled: boolean) {
        this.disabled = isDisabled;
    }

    writeValue(obj: string[]): void {
        if (!obj) {
            this.selected = [];
            this.selectedOld = [];
        } else {
            if (!this.choices || this.choices.length === 0) {
                for (let str of obj) {
                    this.choices = [
                        { id: str, itemName: str },
                        ...this.choices,
                    ];
                }
            }

            this.selectedOld = obj;
            this.oldChange();
        }
    }
    registerOnChange(fn: any): void {
        // console.log('registerOnChange');
        this.setOnChangeCallback(fn);
    }
    registerOnTouched(fn: any): void {
        this.setOnTouchCallback(fn);
    }
    setDisabledState?(isDisabled: boolean): void {
        this.setIsDisabled(isDisabled);
    }

    deselectAll = () => {
        this.selected = [];
        this.formChanged(this.selected);
    };

    formChanged = (input: any) => {
        // console.log('Form Changed', input, this.selected);
        this.selectedOld = this.selected.map(v => v.id);
        for (const change of this.onChanges) {
            change(this.selectedOld);
        }

        this.markAsTouched();
    };

    formTouched = (input: any) => {
        this.touched = true;
        for (const touch of this.onTouched) {
            touch(input);
        }
    };

    markAsTouched() {
        this.touched = true;
        this.formTouched({});
    }

    ngOnChanges(changes: SimpleChanges): void {
        this.settings = {
            singleSelection: this.singleSelection,
            text: this.label,
            lazyLoading: true,
            classes: 'myclass custom-dropdown',
            enableFilterSelectAll: false,
            enableCheckAll: false,
            enableSearchFilter: true,
            disabled: this.disabled,
            required: this.required,
            addNewItemOnFilter: true,
            addNewButtonText: 'Add',
        };
    }

    open = () => {
        this.isOpen = true;
        this.shouldOpen = true;
    };

    closed = event => {
        if (event !== true) {
            this.isOpen = false;

            this.markAsTouched();
        }
    };
}
